import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';
// components
import Page from '../components/Page';
import Iliustration404 from '../assets/ilustrations/illustration_404.svg';
import constants from '../constants';
import { FormattedMessage } from 'react-intl';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <RootStyle>
      <Container>
        <Container initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <Typography variant="h3" paragraph>
              <FormattedMessage id='page404.title' defaultMessage='Sorry, page not found!' />
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              <FormattedMessage
                id='page404.description'
                defaultMessage='Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.'
              />
            </Typography>

            <Box
              component="img"
              src={Iliustration404}
              sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
            />

            <Button to={constants.routes.DASHBOARD.path} size="large" variant="contained" component={RouterLink}>
              <FormattedMessage id='page404.link.home' defaultMessage='Go back to home' />
            </Button>
          </Box>
        </Container>
      </Container>
    </RootStyle>
  );
}
